import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import HelloSign from 'hellosign-embedded';
import { DropboxService } from '../../services/dropbox.service';

@Component({
	selector: 'app-embedded',
	templateUrl: './embedded.component.html',
	styleUrls: ['./embedded.component.css']
})
export class EmbeddedComponent implements OnInit {

	companyId: any;
	projectId: any;
	context: any;
	isSandbox: any;
	isRequest: any;

	usedUrl = false;
	done = false;

	constructor(
		private dropboxService: DropboxService,
		private route: ActivatedRoute
	) { }

	ngOnInit() {
		this.route.queryParams.subscribe(params => {
			if (params['companyId'] && params['url']) {
				this.dropboxService.checkEmbeddedUrl(params['companyId'], params['url']).subscribe((result: any) => {
					if (result.validUrl) {
						const client = new HelloSign();

						client.open(atob(params['url']), {
							clientId: result.clientId,
							skipDomainVerification: true,
							container: document.getElementById('embedded-area')
						});

						client.on('finish', () => {
							window.close();
							this.done = true;
						});
					} else {
						this.usedUrl = true;
					}
				});
			}
			if (params['companyId']) {
				this.companyId = params['companyId'];
			}
			if (params['projectId']) {
				this.projectId = params['projectId'];
			}
			if (params['context']) {
				this.context = params['context'];
			}
			if (params['isSandbox']) {
				this.isSandbox = params['isSandbox'];
			}
			if (params['request']) {
				this.isRequest = params['request'] === '1';
			}
		});
	}

}
